const arr = [
  // { value: 3, text: '财经' },
  { value: 8, text: '时尚' },
  { value: 4, text: '军事' },
  { value: 9, text: '汽车' },
  { value: 11, text: '房产' }
  // { value: 10, text: '体育' },
  // { value: 16, text: '游戏' }
]

const newTabs = [
  {
    channelId: '',
    type: 0,
    str: '要闻'
  },
  {
    channelId: '26916',
    type: 1,
    str: '视频',
    cornerLabelDesc: true
  },
  {
    channelId: '25950',
    type: 3,
    str: '时事',
    cornerLabelDesc: false
  },
  {
    channelId: '25951',
    type: 4,
    str: '财经',
    cornerLabelDesc: false
  },
  {
    channelId: '119908',
    type: 5,
    str: '科技',
    cornerLabelDesc: false
  },
  {
    channelId: '25952',
    type: 6,
    str: '思想'
  },
  {
    channelId: '119489',
    type: 7,
    str: '智库'
  },
  {
    channelId: '25953',
    type: 8,
    str: '生活',
    cornerLabelDesc: false
  }
]

export default newTabs
